import { useState } from 'react'
import { Box, Button, TablePagination, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'

import { useFetch, usePagination } from 'hooks'

import { Card, Permitted, ButtonComponent } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import {
  PaymentServiceDialog,
  ServicesTableRow,
  SyncOmieDialog,
} from './components'

import { routes } from 'Routes'
import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'

const ServicesCard = ({ paymentContract, mode, refreshContract }) => {
  const history = useHistory()
  const theme = useTheme()
  const [openCreateDialog, setOpenCreateDialog] = useState(false)
  const [openSyncDialog, setOpenSyncDialog] = useState(false)
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { response, isLoading, refresh } = useFetch(
    service.dponet.paymentContractServices.get,
    { paymentContractId: paymentContract?.id, perPage, page },
    [page, perPage],
  )

  const paymentServices = response?.data?.paymentServices || []
  const isShow = mode === 'show'
  const totalPrice = paymentContract?.price

  const handleRedirect = (tab) => {
    const action = isShow ? 'show' : 'edit'

    return history.push(
      reverse(routes.contracts[action], {
        contractId: paymentContract?.id,
      }),
      { tab },
    )
  }

  const omieCode = paymentContract?.codeContractOmie

  return (
    <Box mb={2}>
      <Card
        title="Serviços"
        fromTable
        actionButton={
          <Permitted tag={constants.permissions.PAYMENT_CONTRACTS.MANAGE}>
            {!isShow && (
              <Box>
                {omieCode && (
                  <>
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => setOpenSyncDialog(true)}
                    >
                      Sincronizar com omie
                    </Button>{' '}
                  </>
                )}
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() => setOpenCreateDialog(true)}
                >
                  Cadastrar serviço
                </Button>
              </Box>
            )}
          </Permitted>
        }
      >
        <Table
          emptyMessage="Nenhum serviço encontrado"
          isLoading={isLoading}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell width="5%" align="left">
                ID
              </TableCell>
              <TableCell width="25%" align="left">
                Nome
              </TableCell>
              <TableCell width="15%" align="center">
                Valor
              </TableCell>
              <TableCell width="20%" align="center">
                Término
              </TableCell>
              <TableCell width="15%" align="center">
                Renovação
              </TableCell>
              <TableCell width={isShow ? '20' : '15%'} align="center">
                Status
              </TableCell>
              {!isShow && (
                <TableCell width="5%" align="right">
                  Ações
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {paymentServices?.map((paymentService) => (
              <ServicesTableRow
                key={paymentService?.id}
                paymentContractId={paymentContract?.id}
                paymentService={paymentService}
                refresh={refresh}
                isShow={isShow}
                refreshContract={refreshContract}
              />
            ))}
          </TableBody>
        </Table>
        <Box
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" alignItems="center">
            <Box mr={1}>Total:</Box>
            <Box fontWeight="bold">
              R$ {helpers.formatters.currencyInput(totalPrice)}
            </Box>
          </Box>
          <TablePagination
            component="div"
            count={response?.data?.meta?.totalCount || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            page={page - 1}
            rowsPerPage={perPage}
            rowsPerPageOptions={[5, 10, 25, 100]}
            labelRowsPerPage={isDesktop ? 'Por página' : ''}
            nextIconButtonProps={{ size: 'small' }}
            backIconButtonProps={{ size: 'small' }}
          />
        </Box>
      </Card>
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Box mr={2}>
          <ButtonComponent
            variant="outlined"
            onClick={() => handleRedirect('contractor')}
            type="button"
            title="Voltar"
          />
        </Box>
        <ButtonComponent
          onClick={() => handleRedirect('payment')}
          type="button"
          title="Próximo"
        />
      </Box>
      {openCreateDialog && (
        <PaymentServiceDialog
          open={openCreateDialog}
          setOpen={setOpenCreateDialog}
          paymentContractId={paymentContract?.id}
          refresh={refresh}
          refreshContract={refreshContract}
        />
      )}
      {openSyncDialog && (
        <SyncOmieDialog
          open={openSyncDialog}
          setOpen={setOpenSyncDialog}
          paymentContractId={paymentContract?.id}
        />
      )}
    </Box>
  )
}

ServicesCard.propTypes = {
  paymentContract: PropTypes.object,
}

export default ServicesCard
